import { submission } from "../../graphql"
import { graphqlApolloClient } from "../graphql-apollo-client"
import { DELETE_SUBMISSION_SPECIFIC_OBJECTIVES } from "./graphql/delete-submission-specific-objectives"
import { SUBMISSION_OBJECTIVE_WITH_SCHEDULES } from "./graphql/submission-objectives-with-schedules"
import { ACTIVITIES_SPECIFIC_OBJECTIVES, SUBMISSION_TECHNICAL_SPECIFICATIONS } from "./graphql/submission-technical-specifications-query"

const getSubmissionObjectives = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: submission.queries.getObjectives,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.SubmissionObjectives
}

const getSubmissionSpecificObjectives = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: submission.queries.getSpecificObjectives,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.SubmissionObjectives
}

const getSubmissionObjectivesWithSchedules = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: SUBMISSION_OBJECTIVE_WITH_SCHEDULES,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.submissionObjectivesWithSchedules
}

const getSpecificObjectivesBySubmission = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: submission.queries.specificObjectivesBySubmissionQuery,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return data?.SpecificObjectivesBySubmission
}

const deleteSubmissionSpecificObjectives = async ({ ids = [] }) => {
  const { data } = await graphqlApolloClient.mutate({
    mutation: DELETE_SUBMISSION_SPECIFIC_OBJECTIVES,
    variables: {
      ids
    }
  })

  return data?.DeleteSubmissionSpecificObjectives
}

const getSubmissionTechnicalSpecifications = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: SUBMISSION_TECHNICAL_SPECIFICATIONS,
    fetchPolicy: "network-only",
    variables: {
      id
    }
  })

  return {
    TechnicalSpecification: data?.SubmissionTechnicalSpecification || null
  }
}

const getActivitiesSpecificObjectives = async ({ id }) => {
  const { data } = await graphqlApolloClient.query({
    query: ACTIVITIES_SPECIFIC_OBJECTIVES,
    fetchPolicy: "network-only",
    variables: {id}
  })

  return {
    TechnicalSpecification: data?.activitiesSpecificObjectives || null
  }
}

export const SubmissionObjectivesServices = {
  getSubmissionObjectives,
  getSpecificObjectivesBySubmission,
  deleteSubmissionSpecificObjectives,
  getSubmissionTechnicalSpecifications,
  getSubmissionObjectivesWithSchedules,
  getSubmissionSpecificObjectives,
  getActivitiesSpecificObjectives
}
